import autobind from 'class-autobind';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import InterstitialLeftColumn from './interstitial_left_column.jsx';

import { isBasicValidEmail } from 'zoomforth_zfutils/email_validation.js';

import ConsentManagementFlow from 'zoomforth_codesbane_viewer/viewer/consent/consent_modal.jsx';


class IdentificationInterstitial extends Component {

  constructor(){
    super();
    this.state = {
      email: '',
      name: '',
      isWaitingForResponse: false,
      shouldShowEmailError: false
    };
    autobind(this);
  }

  canContinue() {
    const { shouldAskForEmail, shouldAskForName } = this.props;
    const { email, name } = this.state;

    return (
      (shouldAskForEmail ? !!email : true) &&
      (shouldAskForName ? !!name : true)
    );
  }

  handleContinue() {

    // see if we have any email validity issues first
    if (this.state.email) {
      // If you've typed something in the email box then
      // we want to check its validity
      if (!isBasicValidEmail(this.state.email)) {
        this.setState({ 
          shouldShowEmailError: true 
        });
        return;

      } else {
        // reset the validity if there are no errors
        this.setState({ 
          shouldShowEmailError: false
        });
      }        
    }

    this.setState({
      isWaitingForResponse: true
    });

    const data = {
      email: this.state.email,
      name: this.state.name,
      route_id: this.props.routeId
    };

    $.ajax({
      url: '/_rpc/interstitials/self_identify', 
      data: data, 
      type: 'POST',
      dataType: 'json' 
    }).done(
      (response) => {
        // The js runtime stores the source of truth for the public user ID in memory.
        // This is important for users whose cookies don't work, but it also means we end
        // up with consistent identities for the duration of a page.
        this.props.onComplete({
          public_user_id: response.public_user_id
        });
      }
    ).fail(
      ()=> {
        // The server should never reject a request,
        // so this is unlikely to occur here. if it does though, 
        // there is no value surfacing anything to the user
        this.props.onComplete({});
      }
    );
  }

  handleContinueAnonymously() {
    this.props.onComplete({
      should_anonymize: true
    });
  }

  render() {
    const {
      isConsentRequired,
      isConsentCookieSet,
      hasConsentedToTracking,
      hasConsentedToAuthCookie,
      shouldAskForEmail,
      shouldAskForName,
      privacyPolicyUrl,
      routeId,
      accountLogoUrl,
      onConsentChange
    } = this.props;

    const {
      email,
      name,
      isWaitingForResponse,
      shouldShowEmailError
    } = this.state;

    return ( 

      <div className="interstitial-base identification-interstitial">
        <ConsentManagementFlow
          routeId={routeId}
          shouldUpdateTracker={true}
          isConsentRequired={isConsentRequired}
          isConsentCookieSet={isConsentCookieSet}
          hasConsentedToTracking={hasConsentedToTracking}
          hasConsentedToAuthCookie={hasConsentedToAuthCookie}
          privacyPolicyUrl={privacyPolicyUrl}
          onConsentChange={onConsentChange}
        />

        <InterstitialLeftColumn
          accountLogoUrl={accountLogoUrl}
        />

        <div className="col2">
          <form
            onSubmit={(e)=>{
              e.preventDefault();
              if (this.canContinue()) {
                this.handleContinue();
              }
            }}
          >
            <div className="medium-heading">
              Please identify yourself before viewing this content.
            </div>

            {
              shouldAskForName &&

                <div className="input-container">
                  <label htmlFor="name-field" className="field-name">
                    Your Name
                  </label>
                  <div className="field-input">
                    <input 
                      id="name-field"
                      name="name" 
                      type="text" 
                      value={name} 
                      placeholder="Jane Doe" 
                      onChange={
                        (e)=> {
                          this.setState({
                            name: e.target.value
                          });
                        }
                      }
                    />
                  </div>
                </div>
            }
            {
              shouldAskForEmail &&

                <div className="input-container">
                  <label htmlFor="email-field" className="field-name">
                    Your Email
                  </label>
                  <div className="field-input">
                    <input 
                      id="email-field"
                      name="email" 
                      type="text" 
                      value={email} 
                      placeholder="jane.doe@acme.com" 
                      onChange={
                        (e)=>{
                          this.setState({
                            email: e.target.value
                          });
                        }
                      }
                    />
                  </div>
                  {
                    shouldShowEmailError && 
                      <div className="error-message">
                        You must enter a valid email address.
                      </div>
                  }
                </div>
            }

            <div className="continue-button-container">
              <button 
                className="continue-button" 
                disabled={!this.canContinue()}
              >
                { isWaitingForResponse ? '...' : 'Continue' }
              </button>
            </div>

            {
              (isConsentRequired && !hasConsentedToTracking) &&
                <button
                  className="continue-anonymously-button"
                  onClick={this.handleContinueAnonymously}
                >
                  Continue without identifying yourself
                </button>
            }

          </form>
        </div>
      </div>

    );
  }

}

IdentificationInterstitial.propTypes = {
  routeId: PropTypes.number.isRequired,
  onComplete: PropTypes.func.isRequired,
  privacyPolicyUrl: PropTypes.string.isRequired,
  shouldAskForEmail: PropTypes.bool.isRequired,
  shouldAskForName: PropTypes.bool.isRequired
};

export default IdentificationInterstitial;
